import React, { useEffect, useState } from "react";
// import CountryHeader from "../components/Headers/CountryHeader";
import CountryHeader from "./Headers/CountryHeader";
import "./CountryDefault.css";
import AdminDashBoard from "./Admin/AdminDashBoard";
import { useSelector } from "react-redux";
import ProjectDetailBody from "./ProjectDetails/ProjectDetailBody";
import Footer from "../components/Footer";
import { useLocation } from "react-router-dom";
import PageURL from "../constants/PageURL";
import AdminDashBoard2 from "./Admin/AdminDashBoard2";

const CountryDefault = () => {
  const { user = {} } = useSelector((state) => state.user);
  const location = useLocation();

  useEffect(() => {}, [user]);

  return (
    <>
      <div className="main-body-1">
        {/* <CountryHeader a={6} />
        {location.pathname === PageURL.ADMIN_DASHBOARD ? (
          <AdminDashBoard2 />
        ) : ( */}
          <ProjectDetailBody />
        {/* )} <Footer /> */}
      </div>
     
    </>
  );
};

export default CountryDefault;
